import { render, staticRenderFns } from "./seat-navigation-accordion-block.vue?vue&type=template&id=2ab796a3&"
import script from "./seat-navigation-accordion-block.vue?vue&type=script&lang=js&"
export * from "./seat-navigation-accordion-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports